export default "__VITE_ASSET__DPaWVcRV__"